// extracted by mini-css-extract-plugin
module.exports = {"input":"Royalty_input__21jPA"};